module.exports = __webpack_public_path__ + "img/health_status_icon2.f48fd65d.png";